import React, { HTMLAttributes, ReactNode } from 'react';

export interface ButtonGroupProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
}

export const ButtonGroup = ({ children, ...rest }: ButtonGroupProps) => {
  return (
    <div
      className="flex justify-start items-start gap-[10px] px-0 py-0"
      {...rest}
    >
      {children}
    </div>
  );
};
